module.exports = __webpack_public_path__ + "static/media/avatar.bbbf1e9f.png";